import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ColDef, GridApi, GridReadyEvent } from "ag-grid-community";
import { ToastrService } from "ngx-toastr";
import {
  FirmwareUpdateApiService,
  FirmwareVersion
} from "../../shared/services/firmware-update-api/firmware-update-api.service";
import {
  CreateCoreFirmwareVersionComponent
} from "../create-core-firmware-version/create-core-firmware-version.component";
import { FirmwareService, ModuleName } from "../services/firmware/firmware.service";
import { ViewCoreFirmwareModalComponent } from "../view-core-firmware-modal/view-core-firmware-modal.component";

@Component({
  selector: 'dcc-firmware-details',
  templateUrl: './firmware-details.component.html',
  styleUrls: ['./firmware-details.component.scss']
})
export class FirmwareDetailsComponent implements OnInit {
  @Input() module: ModuleName;

  private gridApi!: GridApi<FirmwareVersion>;
  firmwareVersions: FirmwareVersion[] = [];
  nameOfTheModule: string = 'Core Firmware';
  numberOfFirmwareVersions: number = 0;

  constructor(
    private firmwareUpdateApiService: FirmwareUpdateApiService,
    private firmwareService: FirmwareService,
    private toastr: ToastrService,
    private modalService: NgbModal) { }

  async ngOnInit(): Promise<void> {
    await this.getCurrentModuleByName(this.nameOfTheModule);
  }

  modalLinkRederer: (params: any) => HTMLElement = (params) => {
    const link = document.createElement('a');
    link.href = '#';
    link.textContent = params.value;
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const modal = this.modalService.open(ViewCoreFirmwareModalComponent, { size: 'lg', windowClass: "lytxModal", centered: true });
      modal.componentInstance.refreshPage.subscribe(async () => await this.refreshAfterNewFirmwareVersion());
      modal.componentInstance.firmwareVersion = params.data;
    });
    return link;
  };

  columnDefs: ColDef[] = [
    { field: 'name', headerName: "Name", maxWidth: 300, cellRenderer: this.modalLinkRederer },
    { field: 'platformType', headerName: 'Platform Type' },
    { field: 'version', headerName: 'Version' },
    { field: 'build', headerName: 'Build' },
    { field: 'createdDate', headerName: 'Created Date' }
  ];

  defaultColDef: ColDef = {
    sortable: false,
    filter: false,
    resizable: true,
    suppressMovable: true
  };

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    await this.getAllFirmwareVersions();

    window.addEventListener('resize', function () {
      setTimeout(function () {
        params.api.sizeColumnsToFit();
      });
    });
    this.gridApi.sizeColumnsToFit();
  }

  onFirmwareVersionCreateClick() {
    const modal = this.modalService.open(CreateCoreFirmwareVersionComponent, { size: 'lg', windowClass: 'lytxModal', centered: true });
    modal.componentInstance.refreshPage.subscribe(async () => await this.refreshAfterNewFirmwareVersion());
  }

  async getCurrentModuleByName(name: string): Promise<void> {
    try {
      this.module = await this.firmwareService.getModuleByName(name);
    } catch (error) {
      this.toastr.error('Failure retrieving data.');
    }
  }

  async getAllFirmwareVersions(): Promise<void> {
    try {
      this.firmwareVersions = await this.firmwareUpdateApiService.getFirmwareVersions();
      this.firmwareVersions.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
      this.numberOfFirmwareVersions = this.firmwareVersions.length;
      this.gridApi.setRowData(this.firmwareVersions)
    } catch (error) {
      this.toastr.error('Failure retrieving data.');
    }
  }

  async refreshAfterNewFirmwareVersion() {
    await this.onRefresh();
  }

  async onRefresh() {
    this.gridApi.showLoadingOverlay();
    await this.getAllFirmwareVersions();
    this.gridApi.hideOverlay();
    this.gridApi.sizeColumnsToFit();
  }
}
